import dayjs from 'dayjs';

import { PlaidLinkTokenStatements } from 'services/plaid/mutations/usePlaidLinkToken/usePlaidLinkToken.interface';

export default function getLastTwelveMonths(): PlaidLinkTokenStatements {
    const currentDate = dayjs();
    const yesterday = currentDate.subtract(1, 'day');
    const twelveMonthsAgo = currentDate.subtract(12, 'months');

    const startDate = twelveMonthsAgo.startOf('month');

    return {
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: yesterday.format('YYYY-MM-DD'),
    };
}
